var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.485078 10.8872C0.131602 10.5399 0.143791 9.92433 0.472889 9.59523L3.95889 6.10923L0.472889 2.63542C0.143791 2.30023 0.131602 1.69079 0.485078 1.33731C0.838553 0.977743 1.45409 0.989932 1.78319 1.32512L5.26309 4.80503L8.74299 1.32512C9.08428 0.983838 9.68153 0.983838 10.035 1.33731C10.3946 1.69079 10.3946 2.28804 10.0472 2.63542L6.57339 6.10923L10.0472 9.58914C10.3946 9.93652 10.3885 10.5277 10.035 10.8872C9.68763 11.2407 9.08428 11.2407 8.74299 10.8994L5.26309 7.41953L1.78319 10.8994C1.45409 11.2346 0.844647 11.2407 0.485078 10.8872Z",
    fill: "black",
    fillOpacity: 0.2,
    style: {
      fill: "black",
      fillOpacity: 0.2
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.03e6e47e431a0b81527cfc0b1b958dea.svg";
export { ForwardRef as ReactComponent };